import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {Timeline, TimelineLite} from "gsap";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {TOABackgroundIdleView} from "./TOABackgroundIdleView";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";

export class TOABackgroundIdleAnimController implements GameRoundPresentation {
    private _view : TOABackgroundIdleView;

    /**
     * @constructs
     */
    constructor() {
        this._view = new TOABackgroundIdleView();
    }

    /**
     * @inheritDoc
     * @param data
     */
    public getAnimation(data: SpinParsedGameData): Timeline | null {
        if ((data.betWins && data.betWins.length > 0)) {
            return null;
        }


        const tl: TimelineLite = new TimelineLite(),
        startDelay: number = MathHelper.randomIntInRange(2, 5);
        tl.add(()=>this._view.playDustAnimation(), startDelay);
        //tl.add(()=>this._view.playScorpioAnim(), startDelay);

        //This function is called every time this tl is complete. So if does not have a duration it will trigger super ofter causing massive slowdown. Therefore you cant return a tl with only function calls. because it will be complete very quickly thus repeating the process super fast.
        if (tl.duration() > 0) {
            return tl;
        }
        return null;
    }
}